module.exports = __webpack_public_path__ + "static/market-62e23423c48b22dcdf70a187a4e661b2.svg";